import IconDisplayVertical from 'Icons/IconDisplayVertical'
import IconDisplayHorizontal from 'Icons/IconDisplayHorizontal'
import IconSimulator from 'Icons/IconSimulator'
import IconAutorun from 'Icons/IconAutorun'
import IconLive from 'Icons/IconLive'
import IconDisplayHorizontalSuccess from 'Icons/IconDisplayHorizontalSuccess'
import IconDisplayVerticalSuccess from 'Icons/IconDisplayVerticalSuccess'
import IconLeftOneThird from 'Icons/IconLeftOneThird'
import IconRightTwoThirds from 'Icons/IconRightTwoThirds'
import IconDisplayLeft from 'Icons/IconDisplayLeft'
import IconDisplayCenter from 'Icons/IconDisplayCenter'
import IconDisplayRight from 'Icons/IconDisplayRight'
import {
  LEFT_HORIZONTAL_PROPERTY,
  RIGHT_HORIZONTAL_PROPERTY,
  LEFT_SIDE_HORIZONTAL_PROPERTY,
  RIGHT_SIDE_HORIZONTAL_PROPERTY,
  DIGITAL_SIGN_PROPERTY,
  PRESENTATION_SIGN_PROPERTY,
  CENTER_CAST_PROPERTY,
  CENTER_DISPLAY_PROPERTY,
  MOBILE_TOGGLE_PROPERTY,
  AUTORUN_PROPERTY,
  LEFT_SIDE_PROPERTY,
  RIGHT_SIDE_PROPERTY,
} from 'Config'

export const LAUNCH_CARDS = [
  {
    hideInOne: true,
    cardTitle: 'Left Display',
    cardIcon: IconDisplayLeft,
    noMobileCardIcon: IconLeftOneThird,
    cardSubtitle: 'Content',
    disabledFallback: 0,
    defaultDescription: `No special configurations needed. You're all set.`,
    flow: 'column',
    options: [
      {
        label: 'Vertical',
        description: 'Content will be displayed vertically on left display.',
        image: IconDisplayVertical,
        defaultImage: IconDisplayVerticalSuccess,
        profileOptions: [{ key: LEFT_HORIZONTAL_PROPERTY, value: false }],
        isDisabled: () => false,
      },
      {
        label: 'Horizontal',
        description: 'Content will be displayed horizontally on left display.',
        image: IconDisplayHorizontal,
        defaultImage: IconDisplayHorizontalSuccess,
        profileOptions: [{ key: LEFT_HORIZONTAL_PROPERTY, value: true }],
        isDisabled: profile => !profile.trigger.hasOwnProperty(LEFT_SIDE_HORIZONTAL_PROPERTY),
      },
    ],
    urlSuffix: 'left-display',
    getLaunchURL: (collection, simulation) => `/${collection ? collection.id : '_'}/${simulation.id}/left`,
    getVal: profile => {
      return profile.hasOwnProperty(DIGITAL_SIGN_PROPERTY) ||
        !profile.hasOwnProperty(LEFT_HORIZONTAL_PROPERTY) ||
        !profile.trigger.hasOwnProperty(LEFT_SIDE_PROPERTY)
        ? -1
        : profile[LEFT_HORIZONTAL_PROPERTY] && profile.trigger.hasOwnProperty(LEFT_SIDE_HORIZONTAL_PROPERTY)
        ? 1
        : 0
    },
  },
  {
    hideInOne: false,
    cardTitle: 'Center Display',
    cardIcon: IconDisplayCenter,
    cardSubtitle: 'Mobile Experience',
    cardSubtitleOne: 'Content',
    cardTitleOne: 'Single Display',
    disabledFallback: -1,
    disabledDescription: 'This simulation does not have a mobile experience.',
    defaultDescription: `No special configurations needed. You're all set.`,
    flow: 'column',
    options: [
      {
        label: 'Simulator',
        description: `Interact on the display without having a physical phone.`,
        image: IconSimulator,
        profileOptions: [
          { key: CENTER_CAST_PROPERTY, value: false },
          { key: AUTORUN_PROPERTY, value: false },
        ],
        isDisabled: (profile, simulation) => {
          return (
            profile?.trigger?.[CENTER_DISPLAY_PROPERTY]?.display === 'blank' ||
            simulation?.[AUTORUN_PROPERTY] === 'video' ||
            simulation.mobileToggle === 'false'
          )
        },
      },
      {
        label: 'AutoRun',
        description: `Autoplay interactions on the display without having a physical phone.`,
        image: IconAutorun,
        profileOptions: [
          { key: CENTER_CAST_PROPERTY, value: false },
          { key: AUTORUN_PROPERTY, value: true },
        ],
        isDisabled: (profile, simulation) => {
          return (
            !simulation.hasOwnProperty(AUTORUN_PROPERTY) ||
            profile?.trigger?.[CENTER_DISPLAY_PROPERTY]?.display === 'blank' ||
            simulation.mobileToggle === 'false'
          )
        },
      },
      {
        label: 'App',
        description: `Interact on your physical phone while mirroring to the display.`,
        image: IconLive,
        profileOptions: [
          { key: CENTER_CAST_PROPERTY, value: true },
          { key: AUTORUN_PROPERTY, value: false },
        ],
        isDisabled: (profile, simulation) => {
          return (
            !profile?.trigger?.[CENTER_DISPLAY_PROPERTY] ||
            simulation?.[AUTORUN_PROPERTY] === 'video' ||
            simulation.mobileToggle === 'false'
          )
        },
      },
    ],
    urlSuffix: 'center-display',
    getLaunchURL: (collection, simulation, variant) => {
      return `/${collection ? collection.id : '_'}/${simulation.id}/${variant === 'one' ? 'sales' : 'center-display'}`
    },
    getVal: (profile, simulation) => {
      const center = profile?.trigger?.[CENTER_DISPLAY_PROPERTY]
      return !center ||
        (simulation.hasOwnProperty(MOBILE_TOGGLE_PROPERTY) && simulation[MOBILE_TOGGLE_PROPERTY] === 'false')
        ? -1
        : (profile?.trigger?.[CENTER_DISPLAY_PROPERTY]?.display === 'blank' || profile[CENTER_CAST_PROPERTY]) &&
          simulation?.[AUTORUN_PROPERTY] !== 'video'
        ? 2
        : (simulation.hasOwnProperty(AUTORUN_PROPERTY) && profile[AUTORUN_PROPERTY]) ||
          simulation?.[AUTORUN_PROPERTY] === 'video'
        ? 1
        : 0
    },
  },
  {
    hideInOne: true,
    cardTitle: 'Right Display',
    cardIcon: IconDisplayRight,
    noMobileCardIcon: IconRightTwoThirds,
    cardSubtitle: 'Content',
    disabledFallback: 0,
    defaultDescription: `No special configurations needed. You're all set.`,
    flow: 'column',
    options: [
      {
        label: 'Vertical',
        description: 'Content will be displayed vertically on right display.',
        image: IconDisplayVertical,
        defaultImage: IconDisplayVerticalSuccess,
        profileOptions: [{ key: RIGHT_HORIZONTAL_PROPERTY, value: false }],
        isDisabled: () => false,
      },
      {
        label: 'Horizontal',
        description: 'Content will be displayed horizontally on right display.',
        image: IconDisplayHorizontal,
        defaultImage: IconDisplayHorizontalSuccess,
        profileOptions: [{ key: RIGHT_HORIZONTAL_PROPERTY, value: true }],
        isDisabled: profile => !profile.trigger.hasOwnProperty(RIGHT_SIDE_HORIZONTAL_PROPERTY),
      },
    ],
    urlSuffix: 'right-display',
    getLaunchURL: (collection, simulation) => `/${collection ? collection.id : '_'}/${simulation.id}/right`,
    getVal: profile => {
      return profile.hasOwnProperty(PRESENTATION_SIGN_PROPERTY) ||
        !profile.hasOwnProperty(RIGHT_HORIZONTAL_PROPERTY) ||
        !profile.trigger.hasOwnProperty(RIGHT_SIDE_PROPERTY)
        ? -1
        : profile[RIGHT_HORIZONTAL_PROPERTY] && profile.trigger.hasOwnProperty(RIGHT_SIDE_HORIZONTAL_PROPERTY)
        ? 1
        : 0
    },
  },
]

export default { LAUNCH_CARDS }
